    let openRelated = document.querySelector('.open__all-product');
    let productRelated = document.querySelectorAll('.product_rec');
    let openProducts = document.querySelector('.product--section__info-item');

    if(openRelated){
        openRelated.addEventListener('click', function () {
            openProducts.classList.add('none');
            productRelated.forEach((related) => {
                related.classList.add('active');
            });
        });
    }

    let questionsFaqs = document.querySelectorAll('.product-faqs__title');
    let currentFaqs = '';
    if (questionsFaqs) {
        let answers = document.querySelectorAll('.product-faqs__content');
        questionsFaqs.forEach((question, i) => {
            question.addEventListener('click', () => {
                question.parentElement.classList.toggle('active')
                if (question.parentElement.classList.contains("active")) {
                    question.querySelector('.arrow .minus').classList.add('active');
                    question.querySelector('.arrow .plus').classList.add('active')
                    question.nextElementSibling.style.height = question.nextElementSibling.scrollHeight + "px";
                } else {
                    question.querySelector('.arrow .minus').classList.remove('active');
                    question.querySelector('.arrow .plus').classList.remove('active')
                    question.nextElementSibling.style.height = '0';
                }
            });
        });

        function hideAll(answers) {
            for (let i = 0; i < answers.length; i++) {
                answers[i].style.height = '0';
            }
        }

        function showText(question) {
            question.style.height = question.scrollHeight + 'px';
        }
    }